import styled from 'styled-components';
import { Link } from 'fe-appdir-comp-link';

const AppCardDetailsLinkAnchor = styled(Link)`
  color: #fff;
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
  }
`;

AppCardDetailsLinkAnchor.displayName = 'AppCardDetailsLinkAnchor';

export { AppCardDetailsLinkAnchor };
